module.exports = __webpack_public_path__ + "img/battery_new.65a9f045.webp";